import { formatPrice } from "apps/visits/core/utils/format-price";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";

export type ProductsSummaryPriceProps = {
  className?: string;
  price: string | number;
};

export const ProductsSummaryPrice = ({ className, price }: ProductsSummaryPriceProps) => {
  const { t } = useTranslation();
  const classes = twMerge("flex items-center justify-between gap-2", className);

  return (
    <div className={classes}>
      <span className="font-bold text-md">{t("GROUP_ACTIONS_ORDERING.CART.TOTAL_PRICE")}:</span>
      <span className="font-bold text-md text-xl">{formatPrice(price)}</span>
    </div>
  );
};
